import { render, staticRenderFns } from "./InstrumentsContainer.vue?vue&type=template&id=4052f539&scoped=true&"
import script from "./InstrumentsContainer.vue?vue&type=script&lang=ts&"
export * from "./InstrumentsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./InstrumentsContainer.vue?vue&type=style&index=0&id=4052f539&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4052f539",
  null
  
)

export default component.exports